// Modèle d'inventaire d'un emplacement : les thèmes et les objets attendus de son hébergement.
// Collection `accommodations` : { name, location_category_list, inventory: { categories: [...] } }

// Comparaison de libellés : casse, accents, apostrophes et espaces ignorés
export function normalizeText(value)
{
	return (value || '').toString()
		.normalize('NFD').replace(/[̀-ͯ]/g, '')
		.replace(/[’‘`]/g, '\'')
		.toLowerCase()
		.replace(/\s+/g, ' ')
		.trim()
}

// Le serveur rapproche par regex (findLocationCategory) : « Mh 3 chs Confort » y attrape aussi
// « Mh 3 chs Confort Vue Mer ». On cherche d'abord la correspondance exacte, puis la regex.
export function findAccommodation(accommodations, locationCategory)
{
	const list = accommodations || []
	const wanted = normalizeText(locationCategory)
	if (!wanted)
		return null
	for (let i = 0; i < list.length; i++)
	{
		const categories = list[i].location_category_list || []
		if (categories.some(category => normalizeText(category) === wanted))
			return list[i]
	}
	for (let i = 0; i < list.length; i++)
	{
		const categories = list[i].location_category_list || []
		for (let j = 0; j < categories.length; j++)
		{
			let match = false
			try
			{
				match = new RegExp(categories[j].replace(/\(/g, '\\(').replace(/\)/g, '\\)'), 'i').test(locationCategory)
			}
			catch (e)
			{
				match = false
			}
			if (match)
				return list[i]
		}
	}
	return null
}

function translatedName(item, lang)
{
	const translations = (item && item.translations) || []
	const found = translations.find(translation => translation.lang === lang) || translations[0]
	if (found && found.name)
		return found.name.trim()
	return ((item && item.name) || '').trim()
}

// Thèmes dans l'ordre du modèle : [{ id, name, objects: [{ id, name, expected }] }]
export function modelThemes(accommodation, lang = 'fr')
{
	if (!accommodation || !accommodation.inventory)
		return []
	const inventory = accommodation.inventory
	const categories = Array.isArray(inventory) ? inventory : (inventory.categories || [])
	return categories
		.map((category, i) => ({
			id: 't' + i,
			name: translatedName(category, lang),
			objects: (category.objects || []).map((object, j) => ({
				id: 't' + i + '-o' + j,
				name: translatedName(object, lang),
				expected: Math.max(0, parseInt(object.quantity, 10) || 0)
			}))
		}))
		.filter(theme => theme.objects.length > 0)
}

export function countObjects(themes)
{
	return (themes || []).reduce((total, theme) => total + theme.objects.length, 0)
}
